// import React, { useState, useRef, useEffect } from 'react';
// import './home.css';
// import { Header, WhatGPT3, Feed } from '../../containers'
// import { Trending, Brand, CTA, Info } from '../../@/components'
// import { Link } from 'react-router-dom';
// import Slider from 'react-slick';
// import 'slick-carousel/slick/slick.css';
// import 'slick-carousel/slick/slick-theme.css';
// import Modale from '../../containers/feed/Feed';
// import Modal from '../../@/components/modal/Modal';
// import Masonry from 'react-layout-masonry';
// import { excerpt } from '../../@/components/post/excerpt'
// import BlurhashImg from '../../@/components/Image/BlurhashImg';
// import { getDocs, collection, query, orderBy, limit, where, onSnapshot, updateDoc, increment, doc } from 'firebase/firestore';
// import { db } from '../../firebase';
// import { FaFacebook, FaTwitter, FaInstagram, FaPinterest, FaCopy } from 'react-icons/fa';

// import Blog from '../../@/components/blog/Blog'

// // Function to shuffle the array
// const shuffleArray = (array) => {
//   let shuffledArray = [...array];
//   for (let i = shuffledArray.length - 1; i > 0; i--) {
//     const j = Math.floor(Math.random() * (i + 1));
//     [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
//   }
//   return shuffledArray;
// };

// const Home = () => {
//   const [playing, setPlaying] = useState([false, false, false]);
//   const videoRefs = [useRef(null), useRef(null), useRef(null)];
//   const [selectedCategory, setSelectedCategory] = useState('all');
//   const [featuredProjects, setFeaturedProjects] = useState([]);
//   const [stories, setStories] = useState([]);
//   const [modalPost, setModalPost] = useState(null);
//   const [modalIsOpen, setModalIsOpen] = useState(false);
//   const [modalImage, setModalImage] = useState('');
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [posts, setPosts] = useState([]);
//   const [news, setNews] = useState([]);
//   const [shuffledPosts, setShuffledPosts] = useState([]);
//   const videoRef = useRef(null);
//   const [extendedStories, setExtendedStories] = useState([]);
//   const sliderRef = useRef(null);
//   const [activePopupPostId, setActivePopupPostId] = useState(null);
//   const [hoverPostId, setHoverPostId] = useState(null);
//   const [localShareCounts, setLocalShareCounts] = useState({});
//   const [copiedPostId, setCopiedPostId] = useState(null);
//   const [currentOffset, setCurrentOffset] = useState(0);
//   const shareRefsMap = useRef({});

//   const handlePlaysPauses = () => {
//     if (videoRef.current) {
//       setPlaying(!playing);
//       const video = videoRef.current;

//       if (!playing || video.ended) {
//         video.play();
//         setPlaying(true);
//       } else {
//         video.pause();
//         setPlaying(false);
//       }
//     }
//   }; 

//   const handlePlayPause = (index) => {
//     return () => {
//       if (videoRefs[index].current) {
//         const updatedPlaying = [...playing];
//         updatedPlaying[index] = !playing[index];
//         setPlaying(updatedPlaying);

//         const video = videoRefs[index].current;

//         if (!playing[index] || video.ended) {
//           video.play();
//         } else {
//           video.pause();
//         }
//       }
//     };
//   };


//   const handlePlayPauseSec = (index) => {
//     return () => {
//       const updatedPlaying = [...playing];
//       updatedPlaying[index] = !playing[index];
//       setPlaying(updatedPlaying);
  
//       const video = videoRefs[index].current;
  
//       if (!playing[index] || video.ended) {
//         video.play();
//       } else {
//         video.pause();
//       }
//     };
//   };
  
  
//   const handleVideoEnded = (index) => () => {
//     const updatedPlaying = [...playing];
//     updatedPlaying[index] = false;
//     setPlaying(updatedPlaying);
//   };

//   const openModal = (image) => {
//     setModalImage(image);
//     setModalIsOpen(true);
//   };

//   const closeModal = () => {
//     setModalIsOpen(false);
//   };


//   const handleReadMore = (post) => {
//     setModalPost(post);
//   };

//   const handleCategoryChange = (value) => {
//     setSelectedCategory(value);
//   };


//   const filterPosts = () => {
//     if (selectedCategory === 'all') {
//       return posts;
//     }
//     return posts.filter(post => post.categories.includes(parseInt(selectedCategory, 10)));
//   };

//   useEffect(() => {
//     if (videoRef.current) {
//       videoRef.current.setAttribute('muted', true);
//     }
//   }, []);

//   useEffect(() => {
//     // Shuffle posts when the component mounts
//     setShuffledPosts(shuffleArray(posts));
//   }, [posts]);


//   useEffect(() => {
//     const fetchRecentPosts = async () => {
//       try {
//         const postsCollection = collection(db, 'news');
//         const recentPostsQuery = query(
//           postsCollection,
//           orderBy('createdAt', 'desc'),
//           limit(6)
//         );
//         const snapshot = await getDocs(recentPostsQuery);
//         const fetchedPosts = snapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           date: doc.data().createdAt.toDate().toLocaleDateString('en-GB', {
//             day: 'numeric',
//             month: 'long',
//             year: 'numeric'
//           })
//         }));
//         setPosts(fetchedPosts);
//       } catch (error) {
//         console.error("Error fetching recent posts:", error);
//       }
//     };
  
//     fetchRecentPosts();
//   }, []);


//   useEffect(() => {
//     const fetchRecentNews = async () => {
//       try {
//         const postsCollection = collection(db, 'news');
//         const recentPostsQuery = query(
//           postsCollection,
//           orderBy('createdAt', 'desc'),
//           limit(1)
//         );
//         const snapshot = await getDocs(recentPostsQuery);
//         const fetchedNews = snapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           date: doc.data().createdAt.toDate().toLocaleDateString('en-GB', {
//             day: 'numeric',
//             month: 'long',
//             year: 'numeric'
//           })
//         }));
//         setNews(fetchedNews);
//       } catch (error) {
//         console.error("Error fetching recent posts:", error);
//       }
//     };

//     const handleClickOutside = (event) => {
//       let isClickInsideShareArea = false;
      
//       // Check if the click is inside any of the share areas
//       Object.values(shareRefsMap.current).forEach(ref => {
//         if (ref && (ref.buttonRef.contains(event.target) || 
//             (ref.popupRef && ref.popupRef.contains(event.target)))) {
//           isClickInsideShareArea = true;
//         }
//       });
  
//       if (!isClickInsideShareArea) {
//         setActivePopupPostId(null);
//         setHoverPostId(null);
//         setCopiedPostId(null);
//       }
//     };

//     document.addEventListener('click', handleClickOutside);
  
//     fetchRecentNews();

//     // Cleanup event listener
//     return () => {
//       document.removeEventListener('click', handleClickOutside);
//     };
//   }, []);

//   useEffect(() => {
//     const fetchFeaturedProjects = () => {
//       const q = query(collection(db, 'projects'), where('isFeatured', '==', true));
//       const unsubscribe = onSnapshot(q, (querySnapshot) => {
//         const fetchedProjects = querySnapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           featureImage: doc.data().featureImage,
//         }));
        
//         console.log('Fetched featured projects:', fetchedProjects); 
//         setFeaturedProjects(fetchedProjects);
//         setLoading(false); 
//       }, (error) => {
//         console.error('Error fetching featured projects:', error);
//         setError(error.message);
//         setLoading(false); 
//       });

//       return () => unsubscribe(); 
//     };

//     fetchFeaturedProjects();
//   }, []);


//   const fetchFeaturedProjects = async () => {
//     try {
//       const projectsCollection = collection(db, 'projects');
//       const featuredProjectsQuery = query(
//         projectsCollection,
//         where('featured', '==', true),
//         orderBy('createdAt', 'desc'),
//         limit(4)
//       );
//       const snapshot = await getDocs(featuredProjectsQuery);
//       const fetchedProjects = snapshot.docs.map(doc => ({
//         id: doc.id,
//         ...doc.data()
//       }));
//       setFeaturedProjects(fetchedProjects);
//     } catch (error) {
//       console.error("Error fetching featured projects:", error);
//     }
//   };

//   useEffect(() => {
//     const fetchStories = async () => {
//       try {
//         const storiesCollection = collection(db, 'team-members');
//         const storiesQuery = query(
//           storiesCollection,
//           orderBy('createdAt', 'desc')
//         );
//         const snapshot = await getDocs(storiesQuery);
//         const fetchedStories = snapshot.docs.map(doc => ({
//           id: doc.id,
//           ...doc.data(),
//           date: doc.data().createdAt.toDate().toLocaleDateString('en-GB', {
//             day: 'numeric',
//             month: 'long',
//             year: 'numeric'
//           })
//         }));

//         // Create an extended array with enough stories to ensure continuous scrolling
//         const extended = [];
//         const numRepeats = Math.ceil(6 / fetchedStories.length) + 1; // Ensure at least 6 slides
//         for (let i = 0; i < numRepeats; i++) {
//           extended.push(...fetchedStories);
//         }

//         setStories(extended);
//       } catch (error) {
//         console.error("Error fetching stories", error);
//       }
//     };
//     fetchStories();
//   }, []);


//   // Slider animation effect
//   useEffect(() => {
//     // Only start animation when stories are loaded
//     if (stories.length === 0) return;

//     // Calculate total width of all slides
//     const sliderTrack = document.querySelector('.design-stories-slider-track');
//     const slideWidth = document.querySelector('.story-card-wrapper')?.offsetWidth || 310;
//     const totalWidth = slideWidth * (stories.length / 2); // Half because we're using extended array

//     const animateSlider = () => {
//       // Move slider to the right
//       setCurrentOffset((prevOffset) => {
//         // When we've moved the full width, reset instantly
//         if (prevOffset <= -totalWidth) {
//           // Use setTimeout to allow visual transition before resetting
//           setTimeout(() => {
//             setCurrentOffset(0);
//           }, 50000);
//         }
        
//         // Continue moving
//         return prevOffset - 1;
//       });
//     };

//     // Start continuous animation
//     const intervalId = setInterval(animateSlider, 20);

//     // Cleanup interval on component unmount
//     return () => clearInterval(intervalId);
//   }, [stories]);
  
//   const [imageLoaded, setImageLoaded] = useState(false);

//   const handleImageLoad = () => {
//     setImageLoaded(true);
//   };

//   const sliderSettings = {
//     dots: true,
//     infinite: true,
//     speed: 500,
//     slidesToShow: 3,
//     slidesToScroll: 1,
//     initialSlide: 0,
//     responsive: [
//       {
//         breakpoint: 1024,
//         settings: {
//           slidesToShow: 2,
//           slidesToScroll: 1,
//           infinite: true,
//           dots: true
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 1,
//           slidesToScroll: 1,
//           initialSlide: 1
//         }
//       }
//     ]
//   };

//   const customSliderSettings = {
//     ...sliderSettings,
//     autoplay: true,
//     autoplaySpeed: 0, 
//     cssEase: 'linear',
//     speed: 5000, 
//     slidesToShow: 1,
//     slidesToScroll: 1,
//     variableWidth: true,
//     infinite: true,
//     arrows: false,
//     pauseOnHover: false
//   };

//   const getFirstTextSection = (article) => {
//     // If no sections exist, return first 250 chars of main content
//     if (!article?.sections?.length) {
//       const mainContent = article?.content || '';
//       return mainContent.length > 120 ? mainContent.slice(0, 120) + '...' : mainContent;
//     }
  
//     // Find the first text section
//     const firstTextSection = article.sections.find(section => section.type === 'text');
    
//     // If no text section found, return empty string
//     if (!firstTextSection?.content) return '';
    
//     // Strip HTML tags but preserve line breaks and spaces
//     const stripHtml = (html) => {
//       // Replace line breaks with spaces
//       const withLineBreaks = html.replace(/<br\s*\/?>/gi, ' ').replace(/<\/p>/gi, ' ');
//       // Remove all HTML tags
//       const withoutTags = withLineBreaks.replace(/<[^>]*>/g, '');
//       // Remove multiple spaces and trim
//       return withoutTags.replace(/\s+/g, ' ').trim();
//     };
  
//     // Get plain text content
//     const plainText = stripHtml(firstTextSection.content);
    
//     // Return first 250 chars
//     return plainText.length > 120 ? plainText.slice(0, 120) + '...' : plainText;
//   };
  

  
//   const incrementShareCount = async (postId) => {
//     try {
//       const postRef = doc(db, 'news', postId);
//       await updateDoc(postRef, { 
//         shareCount: increment(1) 
//       });
//     } catch (error) {
//       console.error("Error incrementing share count:", error);
//     }
//   };

  
//   const handleShareButtonClick = (postId) => {
//     // Toggle the popup
//     setActivePopupPostId(prevId => prevId === postId ? null : postId);
//     // Ensure hover is also set to allow persistent display
//     setHoverPostId(postId);
//   };

//   const handleCopyLink = (postId) => {
//     const articleUrl = `https://yourwebsite.com/article/${postId}`;
    
//     // Copy to clipboard
//     navigator.clipboard.writeText(articleUrl).then(() => {
//       // Set copied state and reset after 2 seconds
//       setCopiedPostId(postId);
//       setTimeout(() => setCopiedPostId(null), 2000);
//     }).catch(err => {
//       console.error('Failed to copy: ', err);
//     });
//   };

//   const handleSocialShare = async (postId, socialPlatform) => {
//     try {
//       // Increment local share count immediately
//       setLocalShareCounts(prev => ({
//         ...prev,
//         [postId]: (prev[postId] || 0) + 1
//       }));

//       // Increment share count in Firestore
//       await incrementShareCount(postId);

//       // Open the share dialog for the specific social platform
//       let shareUrl = '';
//       const articleUrl = `https://yourwebsite.com/article/${postId}`;
      
//       switch(socialPlatform) {
//         case 'facebook':
//           shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(articleUrl)}`;
//           break;
//         case 'twitter':
//           shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(articleUrl)}`;
//           break;
//         case 'instagram':
//           // Note: Instagram doesn't allow direct sharing via web
//           alert('Instagram sharing is not directly supported. Please copy the link.');
//           return;
//         case 'pinterest':
//           shareUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(articleUrl)}`;
//           break;
//         default:
//           return;
//       }

//       window.open(shareUrl, '_blank');
//     } catch (error) {
//       console.error("Error sharing post:", error);
//     }
//   };



//   return (
//     <div className="/" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
//       <div className='carousel'>
//         <Header />

//         <div className="flex flex-col md:flex-row w-full article-first">
//           {/* Left column - 30% width */}
//           <div className="w-full md:w-[30%] flex flex-col justify-between">
//             <div className='img'>
//               <div
//                 className="category-buttons"
//                 style={{
//                   display: "flex",
//                   flexDirection: "column",
//                   alignItems: "start",
//                   gap: "10px",
//                 }}
//               >
//                 <h1 
//                   className="responsive-title"
//                   style={{
//                     fontFamily: "Poppins-SemiBold", 
//                     color: "#CD3333", 
//                     fontSize: "clamp(28px, 4vw, 37px)",
//                     fontWeight: "900"
//                   }}
//                 >
//                   Published Now
//                 </h1>
//               </div>
//             </div>
            
//             <div className="grid grid-cols-1 gap-6">

//             </div>
            
//             {/* <Modal isOpen={modalIsOpen} onRequestClose={closeModal} image={modalImage} />
//             {modalPost && <Modale post={modalPost} onClose={() => setModalPost(null)} />} */}
//           </div>

//           {/* <div className="w-full md:w-[70%] p-0 md:p-4">
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               {posts.map((post) => (
//                 <Link 
//                   to={`/article/${post.id}`} 
//                   key={post.id} 
//                   className="group block mb-4 cursor-pointer duration-300 overflow-hidden"
//                 >
//                   <div className="aspect-[4/3] w-full relative overflow-hidden">
//                     <BlurhashImg
//                       src={post.coverImage}
//                       alt={post.title}
//                       className="absolute inset-0 w-full h-full object-cover responsive blur_load"
//                       id={`clickableImage${post.id}`}
//                       loading="lazy" 
//                       placeholderColor="#888"
//                       onError={(e) => {
//                         console.error('Error loading image:', post.coverImage);
//                         e.target.src = '/fallback-image.jpg';
//                       }}
//                       onClick={() => openModal(post.coverImage)}
//                     />
//                   </div>

//                   <div className="py-4 px-0">
//                     <p className="font-['Poppins-Regular'] text-[#CD3333] text-base">
//                       {post.category}
//                     </p>
                    
//                     <h3 className="font-['Poppins-SemiBold'] text-2xl font-semibold leading-tight mt-1.5">
//                       {post.title}
//                     </h3>
                    
//                     <div 
//                       className="font-['Poppins-Light'] leading-relaxed text-sm mt-1.5 text-black"
//                       dangerouslySetInnerHTML={{
//                         __html: (() => {
//                           const content = getFirstTextSection(post);
//                           if (!content) return 'No content available';
//                           return content.length > 250 ? content.slice(0, 250) + '...' : content;
//                         })()
//                       }}
//                     />
                    
//                     <div 
//                       className="flex items-center mt-4 relative"
//                       onMouseEnter={() => setHoverPostId(post.id)}
//                       onMouseLeave={() => {
//                         if (activePopupPostId !== post.id) {
//                           setHoverPostId(null);
//                         }
//                       }}
//                     >
//                       <p className="font-['Poppins-Light'] text-base text-[#CD3333]">
//                         {new Date(post.createdAt?.seconds * 1000).toLocaleDateString()}
//                       </p>

//                       <button 
//                         className="ml-12 text-[#CD3333] hover:opacity-80 transition-opacity"
//                         onClick={(e) => {
//                           e.stopPropagation(); 
//                           e.preventDefault(); 
//                           handleShareButtonClick(post.id);
//                         }}
//                       >
//                         Share
//                       </button>

//                       {(hoverPostId === post.id || activePopupPostId === post.id) && (
//                         <div 
//                           className="social-popup absolute right-0 top-full mt-2 z-10 bg-white border border-gray-200 p-3 rounded-lg shadow-lg flex gap-4"
//                           onClick={(e) => e.stopPropagation()} 
//                         >
//                           {[
//                             { Icon: FaFacebook, network: 'facebook' },
//                             { Icon: FaTwitter, network: 'twitter' },
//                             { Icon: FaInstagram, network: 'instagram' },
//                             { Icon: FaPinterest, network: 'pinterest' },
//                           ].map(({ Icon, network }) => (
//                             <a
//                               key={network}
//                               href="#"
//                               className="text-gray-600 hover:text-[#CD3333] transition-colors text-xl"
//                               onClick={(e) => {
//                                 e.preventDefault();
//                                 e.stopPropagation();
//                                 handleSocialShare(post.id, network);
//                               }}
//                             >
//                               <Icon />
//                             </a>
//                           ))}
//                           <a
//                             href="#"
//                             className={`text-xl ${copiedPostId === post.id ? 'text-green-500' : 'text-gray-600 hover:text-[#CD3333]'}`}
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               handleCopyLink(post.id);
//                             }}
//                             title={copiedPostId === post.id ? 'Copied!' : 'Copy Link'}
//                           >
//                             {copiedPostId === post.id ? '✓' : <FaCopy />}
//                           </a>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </Link>
//               ))}
//             </div>
//           </div> */}

//         <div className="w-full md:w-[70%] p-0 md:p-4">
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               {posts.map((post) => (
//                 <Link 
//                   to={`/article/${post.id}`} 
//                   key={post.id} 
//                   className="mb-4 cursor-pointer duration-300"
//                 >
//                   <div className="h-[250px] md:h-[350px] w-full overflow-hidden">
//                     <BlurhashImg
//                       src={post.coverImage}
//                       alt={post.title}
//                       className="w-full h-full object-cover responsive blur_load"
//                       id={`clickableImage${post.id}`}
//                       loading="lazy" 
//                       placeholderColor="#888"
//                       onError={(e) => {
//                         console.error('Error loading image:', post.coverImage);
//                         e.target.src = '/fallback-image.jpg';
//                       }}
//                       onClick={() => openModal(post.coverImage)}
//                     />
//                   </div>
//                   <div className="mt-4">
//                     <p style={{
//                       fontFamily: "Poppins-Regular",
//                       color: "#CD3333",
//                       fontSize: "16px"
//                     }}>
//                       {post.category}
//                     </p>
//                     <h3 style={{
//                       fontFamily: "Poppins-SemiBold",
//                       fontSize: "26px",
//                       fontWeight: "600",
//                       lineHeight: "1.2",
//                       paddingTop: '6px'
//                     }}>
//                       {post.title}
//                     </h3>
//                     <div 
//                       style={{
//                         fontFamily: "Poppins-Light",
//                         lineHeight: "1.3",
//                         color: "#000000",
//                         fontSize: '14px',
//                         paddingTop: '6px'
//                       }}
//                       dangerouslySetInnerHTML={{
//                         __html: (() => {
//                           const content = getFirstTextSection(post);
//                           if (!content) return 'No content available';
//                           // Ensure slicing is applied only to the first text section
//                           return content.length > 250 ? content.slice(0, 250) + '...' : content;
//                         })()
//                       }}
                       
//                     />
//                     <div 
//                       className="flex items-center mt-4 relative"
//                       onMouseEnter={() => setHoverPostId(post.id)}
//                       onMouseLeave={() => {
//                         if (activePopupPostId !== post.id) {
//                           setHoverPostId(null);
//                         }
//                       }}
//                     >
//                       <p style={{
//                         fontFamily: "Poppins-Light",
//                         fontSize: "16px",
//                         color: "#CD3333",
//                       }}>
//                         {new Date(post.createdAt?.seconds * 1000).toLocaleDateString()}
//                       </p>

//                       <span className="ml-12" style={{color: "#CD3333"}}>
//                       </span>
//                       <button 
//                         className="share-button ml-2"
//                         onClick={(e) => {
//                           e.stopPropagation(); 
//                           e.preventDefault(); 
//                           handleShareButtonClick(post.id);
//                         }}
//                         style={{color: "#CD3333"}}
//                       >
//                         Share
//                       </button>

//                       {(hoverPostId === post.id || activePopupPostId === post.id) && (
//                         <div 
//                           className="social-popup absolute z-10 bg-white border border-gray-200 p-3"
//                           onClick={(e) => e.stopPropagation()} 
//                         >
//                           <a
//                             href="#"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="issue-details__social-link-feed"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               handleSocialShare(post.id, 'facebook');
//                             }}
//                           >
//                             <FaFacebook />
//                           </a>
//                           <a
//                             href="#"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="issue-details__social-link-feed"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               handleSocialShare(post.id, 'twitter');
//                             }}
//                           >
//                             <FaTwitter />
//                           </a>
//                           <a
//                             href="#"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="issue-details__social-link-feed"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               handleSocialShare(post.id, 'instagram');
//                             }}
//                           >
//                             <FaInstagram />
//                           </a>
//                           <a
//                             href="#"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="issue-details__social-link-feed"
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               handleSocialShare(post.id, 'pinterest');
//                             }}
//                           >
//                             <FaPinterest />
//                           </a>
//                           <a
//                             href="#"
//                             className={`issue-details__social-link-feed ${
//                               copiedPostId === post.id ? 'text-green-500' : ''
//                             }`}
//                             onClick={(e) => {
//                               e.preventDefault();
//                               e.stopPropagation();
//                               handleCopyLink(post.id);
//                             }}
//                             title={copiedPostId === post.id ? 'Copied!' : 'Copy Link'}
//                           >
//                             {copiedPostId === post.id ? '✓ Copied' : <FaCopy />}
//                           </a>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </Link>
//               ))}
//             </div>
            
//             <Modal isOpen={modalIsOpen} onRequestClose={closeModal} image={modalImage} />
//             {modalPost && <Modale post={modalPost} onClose={() => setModalPost(null)} />}
//           </div>

//         </div>

//         <div style={{ maxHeight: '750px', overflowY: 'auto', borderTop: "1px solid #000", margin: "1rem 2rem" }}></div>
//         <div style={{ paddingBottom: '4rem' }}>
//           <div className="post-grid" style={{ maxHeight: '750px', overflowY: 'auto' }}>
//           <div classname="width-hr"> </div>
//           <div className="category-buttons" style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
//             <h1 className="" style={{ fontFamily: "Poppins-SemiBold", color: "#CD3333", fontSize: "clamp(28px, 4vw, 37px)", fontWeight: "600" }}>Design Spotlight</h1>
//               <p className="width-p">
//                 Designed to the exacting European Designed to the exacting European Passive House Standard, this is architect Cedric Burgers’s family home, Passive House Standard, this is architect Cedric Burgers’s family home,
//               </p>
//           </div>
            

//             <Masonry columns={{ 640: 1, 768: 2, 1024: 3 }} gap={16} columnProps={{ className: 'post-container' }}>
//               {featuredProjects.map((project) => (
//                 <div key={project.id} style={{ marginBottom: "0px" }}>
//                   <BlurhashImg 
//                     src={project.featureImage || project.coverImage} 
//                     alt="Post Featured Image" 
//                     className="responsive blur_load"
//                     id={`clickableImage${project.id}`} 
//                     onClick={() => openModal(project.coverImage)} 
//                     placeholderColor="#888"
//                   />
//                 </div>
//               ))}
//             </Masonry>
//           </div>
//         </div>
//         <div style={{ maxHeight: '750px', overflowY: 'auto', borderTop: "1px solid #000", margin: "1rem 2rem 1.4rem 2rem" }}></div>

//         <Trending />

//         <Blog />

//         <Feed />

//         <Brand />

//         <div className="featured-projects">
//           <div
//             className="section-header"
//             style={{
//               display: 'flex',
//               justifyContent: 'space-between',
//               alignItems: 'center',
//               padding: '0 40px',
//               marginBottom: '20px',
//             }}
//           >
//             <h1
//               style={{
//                 fontFamily: 'Poppins-SemiBold',
//                 color: '#CD3333',
//                 fontSize: 'clamp(28px, 4vw, 37px)',
//                 fontWeight: '600',
//                 margin: 0,
//               }}
//             >
//               Designer’s Stories
//             </h1>
//             <Link
//               to="/stories"
//               style={{
//                 color: '#000',
//                 textDecoration: 'none',
//                 fontSize: '14px',
//               }}
//             >
//               View all Stories
//             </Link>
//           </div>

//           <div className="design-stories-slider-wrapper" style={{ overflow: 'hidden', position: 'relative' }}>
//             <Slider {...customSliderSettings} className="design-stories-slider">
//               {stories.map((project, index) => (
//                 <div
//                   key={index}
//                   className="story-card-wrapper"
//                   style={{
//                     width: '300px',
//                     padding: '0 10px',
//                     boxSizing: 'border-box',
//                   }}
//                 >
//                   <Link to={`/stories/${project.slug}`} className="story-card">
//                     <div className="story-image">
//                       <BlurhashImg
//                         src={project.featureImage || project.coverImage}
//                         placeholderColor="#1E1E1E"
//                       />
//                       <div className="story-content">
//                         <span className="category">{project.category}</span>
//                         <h2>{project.title || 'Lorem ipsum dolor sit amet, consectetur adipiscing'}</h2>
//                         <p>
//                           {project.description ||
//                             'Designed to the exacting European Passive House Standard, this is architect Cedric Burgers’s family home.'}
//                         </p>
//                       </div>
//                     </div>
//                   </Link>
//                 </div>
//               ))}
//             </Slider>
//           </div>

//           <style>{`
//             .design-stories-slider .slick-track {
//               display: flex !important;
//             }
//             .design-stories-slider .slick-slide {
//               display: flex !important;
//               height: auto !important;
//             }
//           `}</style>
//         </div>

//         <CTA />

//         <Info />
        
//         <WhatGPT3 />

//       </div> 
//     </div>
    
//   );
// }

// export default Home;















import React, { useState, useRef, useEffect } from 'react';
import './home.css';
import { Header, WhatGPT3, Feed } from '../../containers'
import { Trending, Brand, CTA, Info } from '../../@/components'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Modale from '../../containers/feed/Feed';
import Modal from '../../@/components/modal/Modal';
import Masonry from 'react-layout-masonry';
import { excerpt } from '../../@/components/post/excerpt'
import BlurhashImg from '../../@/components/Image/BlurhashImg';
import { getDocs, collection, query, orderBy, limit, where, onSnapshot, updateDoc, increment, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import { FaFacebook, FaTwitter, FaInstagram, FaPinterest, FaCopy } from 'react-icons/fa';

import Blog from '../../@/components/blog/Blog'

// Function to shuffle the array
const shuffleArray = (array) => {
  let shuffledArray = [...array];
  for (let i = shuffledArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffledArray[i], shuffledArray[j]] = [shuffledArray[j], shuffledArray[i]];
  }
  return shuffledArray;
};

const Home = () => {
  const [playing, setPlaying] = useState([false, false, false]);
  const videoRefs = [useRef(null), useRef(null), useRef(null)];
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [featuredProjects, setFeaturedProjects] = useState([]);
  const [stories, setStories] = useState([]);
  const [modalPost, setModalPost] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalImage, setModalImage] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [posts, setPosts] = useState([]);
  const [news, setNews] = useState([]);
  const [shuffledPosts, setShuffledPosts] = useState([]);
  const videoRef = useRef(null);
  const [extendedStories, setExtendedStories] = useState([]);
  const sliderRef = useRef(null);
  const [activePopupPostId, setActivePopupPostId] = useState(null);
  const [hoverPostId, setHoverPostId] = useState(null);
  const [localShareCounts, setLocalShareCounts] = useState({});
  const [copiedPostId, setCopiedPostId] = useState(null);
  const [currentOffset, setCurrentOffset] = useState(0);
  const shareRefsMap = useRef({});

  const handlePlaysPauses = () => {
    if (videoRef.current) {
      setPlaying(!playing);
      const video = videoRef.current;

      if (!playing || video.ended) {
        video.play();
        setPlaying(true);
      } else {
        video.pause();
        setPlaying(false);
      }
    }
  }; 

  const handlePlayPause = (index) => {
    return () => {
      if (videoRefs[index].current) {
        const updatedPlaying = [...playing];
        updatedPlaying[index] = !playing[index];
        setPlaying(updatedPlaying);

        const video = videoRefs[index].current;

        if (!playing[index] || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      }
    };
  };


  const handlePlayPauseSec = (index) => {
    return () => {
      const updatedPlaying = [...playing];
      updatedPlaying[index] = !playing[index];
      setPlaying(updatedPlaying);
  
      const video = videoRefs[index].current;
  
      if (!playing[index] || video.ended) {
        video.play();
      } else {
        video.pause();
      }
    };
  };
  
  
  const handleVideoEnded = (index) => () => {
    const updatedPlaying = [...playing];
    updatedPlaying[index] = false;
    setPlaying(updatedPlaying);
  };

  const openModal = (image) => {
    setModalImage(image);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };


  const handleReadMore = (post) => {
    setModalPost(post);
  };

  const handleCategoryChange = (value) => {
    setSelectedCategory(value);
  };


  const filterPosts = () => {
    if (selectedCategory === 'all') {
      return posts;
    }
    return posts.filter(post => post.categories.includes(parseInt(selectedCategory, 10)));
  };

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.setAttribute('muted', true);
    }
  }, []);

  useEffect(() => {
    // Shuffle posts when the component mounts
    setShuffledPosts(shuffleArray(posts));
  }, [posts]);


  useEffect(() => {
    const fetchRecentPosts = async () => {
      try {
        const postsCollection = collection(db, 'news');
        const recentPostsQuery = query(
          postsCollection,
          orderBy('createdAt', 'desc'),
          limit(6)
        );
        const snapshot = await getDocs(recentPostsQuery);
        const fetchedPosts = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          date: doc.data().createdAt.toDate().toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })
        }));
        setPosts(fetchedPosts);
      } catch (error) {
        console.error("Error fetching recent posts:", error);
      }
    };
  
    fetchRecentPosts();
  }, []);


  useEffect(() => {
    const fetchRecentNews = async () => {
      try {
        const postsCollection = collection(db, 'news');
        const recentPostsQuery = query(
          postsCollection,
          orderBy('createdAt', 'desc'),
          limit(1)
        );
        const snapshot = await getDocs(recentPostsQuery);
        const fetchedNews = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          date: doc.data().createdAt.toDate().toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })
        }));
        setNews(fetchedNews);
      } catch (error) {
        console.error("Error fetching recent posts:", error);
      }
    };

    const handleClickOutside = (event) => {
      let isClickInsideShareArea = false;
      
      // Check if the click is inside any of the share areas
      Object.values(shareRefsMap.current).forEach(ref => {
        if (ref && (ref.buttonRef.contains(event.target) || 
            (ref.popupRef && ref.popupRef.contains(event.target)))) {
          isClickInsideShareArea = true;
        }
      });
  
      if (!isClickInsideShareArea) {
        setActivePopupPostId(null);
        setHoverPostId(null);
        setCopiedPostId(null);
      }
    };

    document.addEventListener('click', handleClickOutside);
  
    fetchRecentNews();

    // Cleanup event listener
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchFeaturedProjects = () => {
      const q = query(collection(db, 'projects'), where('isFeatured', '==', true));
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const fetchedProjects = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          featureImage: doc.data().featureImage,
        }));
        
        console.log('Fetched featured projects:', fetchedProjects); 
        setFeaturedProjects(fetchedProjects);
        setLoading(false); 
      }, (error) => {
        console.error('Error fetching featured projects:', error);
        setError(error.message);
        setLoading(false); 
      });

      return () => unsubscribe(); 
    };

    fetchFeaturedProjects();
  }, []);


  const fetchFeaturedProjects = async () => {
    try {
      const projectsCollection = collection(db, 'projects');
      const featuredProjectsQuery = query(
        projectsCollection,
        where('featured', '==', true),
        orderBy('createdAt', 'desc'),
        limit(4)
      );
      const snapshot = await getDocs(featuredProjectsQuery);
      const fetchedProjects = snapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setFeaturedProjects(fetchedProjects);
    } catch (error) {
      console.error("Error fetching featured projects:", error);
    }
  };

  useEffect(() => {
    const fetchStories = async () => {
      try {
        const storiesCollection = collection(db, 'team-members');
        const storiesQuery = query(
          storiesCollection,
          orderBy('createdAt', 'desc')
        );
        const snapshot = await getDocs(storiesQuery);
        const fetchedStories = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          date: doc.data().createdAt.toDate().toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })
        }));

        const extended = [];
        const numRepeats = Math.ceil(6 / fetchedStories.length) + 1; 
        for (let i = 0; i < numRepeats; i++) {
          extended.push(...fetchedStories);
        }

        setStories(extended);
      } catch (error) {
        console.error("Error fetching stories", error);
      }
    };
    fetchStories();
  }, []);


  // Slider animation effect
  useEffect(() => {
    if (stories.length === 0) return;

    const sliderTrack = document.querySelector('.design-stories-slider-track');
    const slideWidth = document.querySelector('.story-card-wrapper')?.offsetWidth || 310;
    const totalWidth = slideWidth * (stories.length / 2); 

    const animateSlider = () => {
      setCurrentOffset((prevOffset) => {
        if (prevOffset <= -totalWidth) {
          setTimeout(() => {
            setCurrentOffset(0);
          }, 50000);
        }
        
        return prevOffset - 1;
      });
    };

    const intervalId = setInterval(animateSlider, 20);

    return () => clearInterval(intervalId);
  }, [stories]);
  
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleImageLoad = () => {
    setImageLoaded(true);
  };

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          initialSlide: 1
        }
      }
    ]
  };

  const customSliderSettings = {
    ...sliderSettings,
    autoplay: true,
    autoplaySpeed: 0, 
    cssEase: 'linear',
    speed: 5000, 
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    arrows: false,
    pauseOnHover: false
  };

  const getFirstTextSection = (article) => {
    if (!article?.sections?.length) {
      const mainContent = article?.content || '';
      return mainContent.length > 120 ? mainContent.slice(0, 120) + '...' : mainContent;
    }
  
    const firstTextSection = article.sections.find(section => section.type === 'text');
    
    if (!firstTextSection?.content) return '';
    
    const stripHtml = (html) => {
      const withLineBreaks = html.replace(/<br\s*\/?>/gi, ' ').replace(/<\/p>/gi, ' ');
      const withoutTags = withLineBreaks.replace(/<[^>]*>/g, '');
      return withoutTags.replace(/\s+/g, ' ').trim();
    };
  
    const plainText = stripHtml(firstTextSection.content);
    
    return plainText.length > 120 ? plainText.slice(0, 120) + '...' : plainText;
  };
  

  
  const incrementShareCount = async (postId) => {
    try {
      const postRef = doc(db, 'news', postId);
      await updateDoc(postRef, { 
        shareCount: increment(1) 
      });
    } catch (error) {
      console.error("Error incrementing share count:", error);
    }
  };

  
  const handleShareButtonClick = (postId) => {
    setActivePopupPostId(prevId => prevId === postId ? null : postId);
    setHoverPostId(postId);
  };

  const handleCopyLink = (postId) => {
    const articleUrl = `https://yourwebsite.com/article/${postId}`;
    
    navigator.clipboard.writeText(articleUrl).then(() => {
      setCopiedPostId(postId);
      setTimeout(() => setCopiedPostId(null), 2000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
    });
  };

  const handleSocialShare = async (postId, socialPlatform) => {
    try {
      // Increment local share count immediately
      setLocalShareCounts(prev => ({
        ...prev,
        [postId]: (prev[postId] || 0) + 1
      }));

      // Increment share count in Firestore
      await incrementShareCount(postId);

      // Open the share dialog for the specific social platform
      let shareUrl = '';
      const articleUrl = `https://yourwebsite.com/article/${postId}`;
      
      switch(socialPlatform) {
        case 'facebook':
          shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(articleUrl)}`;
          break;
        case 'twitter':
          shareUrl = `https://twitter.com/intent/tweet?url=${encodeURIComponent(articleUrl)}`;
          break;
        case 'instagram':
          // Note: Instagram doesn't allow direct sharing via web
          alert('Instagram sharing is not directly supported. Please copy the link.');
          return;
        case 'pinterest':
          shareUrl = `https://www.pinterest.com/pin/create/button/?url=${encodeURIComponent(articleUrl)}`;
          break;
        default:
          return;
      }

      window.open(shareUrl, '_blank');
    } catch (error) {
      console.error("Error sharing post:", error);
    }
  };


  // if (loading)
  //   return (
  //     <div className="loading-container">
  //       <div className="spinner"></div>
  //       <p>Loading projects...</p>
  //     </div>
  //   );
  // if (error)
  //   return (
  //     <div className="error-container">
  //       <div className="error-icon">⚠️</div>
  //       <p>Error: {error}</p>
  //     </div>
  //   );


  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-red-600"></div>
        <p className="ml-4 text-lg">Loading Home...</p>
      </div>
    );
  }
  

  return (
    <div className="/" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
      <div className='carousel'>
        <Header />

        <div className="flex flex-col md:flex-row w-full article-first">
          {/* Left column - 30% width */}
          <div className="w-full md:w-[30%] flex flex-col justify-between">
            <div className='img'>
              <div
                className="category-buttons"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "start",
                  gap: "10px",
                }}
              >
                <h1 
                  className="responsive-title"
                  style={{
                    fontFamily: "Poppins-SemiBold", 
                    color: "#CD3333", 
                    fontSize: "clamp(28px, 4vw, 37px)",
                    fontWeight: "900"
                  }}
                >
                  Published Now
                </h1>
              </div>
            </div>
            
            <div className="grid grid-cols-1 gap-6">

            </div>
            
            {/* <Modal isOpen={modalIsOpen} onRequestClose={closeModal} image={modalImage} />
            {modalPost && <Modale post={modalPost} onClose={() => setModalPost(null)} />} */}
          </div>

        {/* <div className="w-full md:w-[70%] p-0 md:p-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4"> */}
        <div className="works-container-pub">
          <div className="work-cards-pub">
            {posts.map((post) => (
              <Link 
                to={`/article/${post.id}`} 
                key={post.id} 
                className="mb-4 cursor-pointer duration-300"
              >
                {/* <div className="h-[250px] md:h-[350px] w-full overflow-hidden">
                  <BlurhashImg
                    src={post.coverImage}
                    alt={post.title}
                    className="w-full h-full object-cover responsive blur_load"
                    id={`clickableImage${post.id}`}
                    loading="lazy" 
                    placeholderColor="#888"
                    onError={(e) => {
                      console.error('Error loading image:', post.coverImage);
                      e.target.src = '/fallback-image.jpg';
                    }}
                    onClick={() => openModal(post.coverImage)}
                  />
                </div> */}
                <div className="relative aspect-[16/9] w-full overflow-hidden">
                  <BlurhashImg
                    src={post.coverImage}
                    alt={post.title}
                    className="absolute inset-0 w-full h-full object-cover responsive blur_load"
                    id={`clickableImage${post.id}`}
                    loading="lazy" 
                    placeholderColor="#888"
                    onError={(e) => {
                      console.error('Error loading image:', post.coverImage);
                      e.target.src = '/fallback-image.jpg';
                    }}
                    onClick={() => openModal(post.coverImage)}
                  />
                </div>
                <div className="mt-4">
                  <p style={{
                    fontFamily: "Poppins-Regular",
                    color: "#CD3333",
                    fontSize: "16px"
                  }}>
                    {post.category}
                  </p>
                  <h3 style={{
                    fontFamily: "Poppins-SemiBold",
                    fontSize: "26px",
                    fontWeight: "600",
                    lineHeight: "1.2",
                    paddingTop: '6px'
                  }}>
                    {post.title}
                  </h3>
                  <div 
                    style={{
                      fontFamily: "Poppins-Light",
                      lineHeight: "1.3",
                      color: "#000000",
                      fontSize: '14px',
                      paddingTop: '6px'
                    }}
                    dangerouslySetInnerHTML={{
                      __html: (() => {
                        const content = getFirstTextSection(post);
                        if (!content) return 'No content available';
                        return content.length > 250 ? content.slice(0, 250) + '...' : content;
                      })()
                    }}
                      
                  />
                  <div 
                    className="flex items-center mt-4 relative"
                    onMouseEnter={() => setHoverPostId(post.id)}
                    onMouseLeave={() => {
                      if (activePopupPostId !== post.id) {
                        setHoverPostId(null);
                      }
                    }}
                  >
                    <p style={{
                      fontFamily: "Poppins-Light",
                      fontSize: "16px",
                      color: "#CD3333",
                    }}>
                      {new Date(post.createdAt?.seconds * 1000).toLocaleDateString()}
                    </p>

                    <span className="ml-12" style={{color: "#CD3333"}}>
                    </span>
                    <button 
                      className="share-button ml-2"
                      onClick={(e) => {
                        e.stopPropagation(); 
                        e.preventDefault(); 
                        handleShareButtonClick(post.id);
                      }}
                      style={{color: "#CD3333"}}
                    >
                      Share
                    </button>

                    {(hoverPostId === post.id || activePopupPostId === post.id) && (
                      <div 
                        className="social-popup absolute z-10 bg-white border border-gray-200 p-3"
                        onClick={(e) => e.stopPropagation()} 
                      >
                        <a
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="issue-details__social-link-feed"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleSocialShare(post.id, 'facebook');
                          }}
                        >
                          <FaFacebook />
                        </a>
                        <a
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="issue-details__social-link-feed"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleSocialShare(post.id, 'twitter');
                          }}
                        >
                          <FaTwitter />
                        </a>
                        <a
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="issue-details__social-link-feed"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleSocialShare(post.id, 'instagram');
                          }}
                        >
                          <FaInstagram />
                        </a>
                        <a
                          href="#"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="issue-details__social-link-feed"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleSocialShare(post.id, 'pinterest');
                          }}
                        >
                          <FaPinterest />
                        </a>
                        <a
                          href="#"
                          className={`issue-details__social-link-feed ${
                            copiedPostId === post.id ? 'text-green-500' : ''
                          }`}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleCopyLink(post.id);
                          }}
                          title={copiedPostId === post.id ? 'Copied!' : 'Copy Link'}
                        >
                          {copiedPostId === post.id ? '✓ Copied' : <FaCopy />}
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </Link>
            ))}
          </div>
            
            <Modal isOpen={modalIsOpen} onRequestClose={closeModal} image={modalImage} />
            {modalPost && <Modale post={modalPost} onClose={() => setModalPost(null)} />}
          </div>

        </div>

        <div style={{ maxHeight: '750px', overflowY: 'auto', borderTop: "1px solid #000", margin: "1rem 2rem" }}></div>
        <div style={{ paddingBottom: '4rem' }}>
          <div className="post-grid" style={{ maxHeight: '750px', overflowY: 'auto' }}>
          <div classname="width-hr"> </div>
          <div className="category-buttons" style={{ display: "flex", flexDirection: "column", alignItems: "start" }}>
            <h1 className="" style={{ fontFamily: "Poppins-SemiBold", color: "#CD3333", fontSize: "clamp(28px, 4vw, 37px)", fontWeight: "600" }}>Design Spotlight</h1>
              <p className="width-p">
                Designed to the exacting European Designed to the exacting European Passive House Standard, this is architect Cedric Burgers’s family home, Passive House Standard, this is architect Cedric Burgers’s family home,
              </p>
          </div>
            

            <Masonry columns={{ 640: 1, 768: 2, 1024: 3 }} gap={16} columnProps={{ className: 'post-container' }}>
              {featuredProjects.map((project) => (
                <div key={project.id} style={{ marginBottom: "0px" }}>
                  <BlurhashImg 
                    src={project.featureImage || project.coverImage} 
                    alt="Post Featured Image" 
                    className="responsive blur_load"
                    id={`clickableImage${project.id}`} 
                    onClick={() => openModal(project.coverImage)} 
                    placeholderColor="#888"
                  />
                </div>
              ))}
            </Masonry>
          </div>
        </div>
        <div style={{ maxHeight: '750px', overflowY: 'auto', borderTop: "1px solid #000", margin: "1rem 2rem 1.4rem 2rem" }}></div>

        <Trending />

        <Blog />

        <Feed />

        <Brand />

        <div className="featured-projects">
          <div
            className="section-header"
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              padding: '0 40px',
              marginBottom: '20px',
            }}
          >
            <h1
              style={{
                fontFamily: 'Poppins-SemiBold',
                color: '#CD3333',
                fontSize: 'clamp(28px, 4vw, 37px)',
                fontWeight: '600',
                margin: 0,
              }}
            >
              Designer’s Stories
            </h1>
            <Link
              to="/stories"
              style={{
                color: '#000',
                textDecoration: 'none',
                fontSize: '14px',
              }}
            >
              View all Stories
            </Link>
          </div>

          <div className="design-stories-slider-wrapper" style={{ overflow: 'hidden', position: 'relative' }}>
            <Slider {...customSliderSettings} className="design-stories-slider">
              {stories.map((project, index) => (
                <div
                  key={index}
                  className="story-card-wrapper"
                  style={{
                    width: '300px',
                    padding: '0 10px',
                    boxSizing: 'border-box',
                  }}
                >
                  <Link to={`/stories/${project.slug}`} className="story-card">
                    <div className="story-image">
                      <BlurhashImg
                        src={project.featureImage || project.coverImage}
                        placeholderColor="#1E1E1E"
                      />
                      <div className="story-content">
                        <span className="category">{project.category}</span>
                        <h2>{project.title || 'Lorem ipsum dolor sit amet, consectetur adipiscing'}</h2>
                        <p>
                          {project.description ||
                            'Designed to the exacting European Passive House Standard, this is architect Cedric Burgers’s family home.'}
                        </p>
                      </div>
                    </div>
                  </Link>
                </div>
              ))}
            </Slider>
          </div>

          <style>{`
            .design-stories-slider .slick-track {
              display: flex !important;
            }
            .design-stories-slider .slick-slide {
              display: flex !important;
              height: auto !important;
            }
          `}</style>
        </div>

        <CTA />

        <Info />
        
        <WhatGPT3 />

      </div> 
    </div>
    
  );
}

export default Home;

